/**
 * Détection préventive du support WebGL.
 *
 * MapLibre GL a besoin d'un contexte WebGL (ou WebGL2) pour s'initialiser.
 * Sur certains devices/navigateurs (GPU bloqué, accélération matérielle
 * désactivée, Firefox en safe mode...), `new maplibregl.Map()` throw
 * `Failed to initialize WebGL` de façon synchrone.
 *
 * En testant la disponibilité de WebGL AVANT d'instancier MapLibre, on
 * évite complètement cette erreur (et son bruit console) plutôt que de
 * compter uniquement sur un Error Boundary pour la rattraper après coup.
 *
 * Voir docs/PRDs/PRD-map-error-boundary-fallback.md
 */
export function isWebGLAvailable(): boolean {
  try {
    const canvas = document.createElement('canvas');
    return !!(
      canvas.getContext('webgl2') ||
      canvas.getContext('webgl') ||
      canvas.getContext('experimental-webgl')
    );
  } catch {
    return false;
  }
}
